import { css } from '@emotion/react'
import { type HTMLMotionProps, motion } from 'motion/react'
import { forwardRef } from 'react'

export interface PostVideoProps extends HTMLMotionProps<'video'> {}

export default forwardRef<HTMLVideoElement, PostVideoProps>(function PostVideo({ ...props }, ref) {
	return (
		<motion.video
			ref={ref}
			controls
			muted
			height="364px"
			{...props}
			css={css`
				&:not(:fullscreen) {
					border-radius: 8px;
					object-fit: cover;
					max-width: 100%;
					width: fit-content;
				}
			`}
		/>
	)
})
